module.exports = __webpack_public_path__ + "static/media/high-none-3.b9a08bd9.png";